import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { when } from 'mobx'
import { observer, inject } from 'mobx-react'

@inject(['auth'])
@observer
class PasswordResetRequest extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    }

    state = {
        error: false,
        processing: false
    }

    componentWillMount() {
        const { location: { state } } = this.props

        this.authWatcher = when(
            () => this.props.auth.resetRequested,
            () => this.context.router.push(state && state.return_to || { pathname: '/login/password-reset/submitted' })
        )
    }

    componentWillUnmount() {
        this.authWatcher()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.setState({ error: false, processing: true })

        const email = this.email.value
        this.props.auth.passwordResetRequest(email)
            .catch(() => { this.setState({ error: true, processing: false })})
    }

    render() {
        let errorMessage = this.state.error && <div className="error">Something appears to have gone wrong!</div>

        return (
            <div className="container auth">
                <div className="dialog login" style={{textAlign: 'center'}}>
                    <h3>Reset Your Password</h3>
                    <p>Please enter your account email to receive a password reset link.</p>
                    <form onSubmit={this.handleSubmit}>
                        {errorMessage}
                        <div className="form-section">
                            <label htmlFor="email" style={{ textAlign: 'left' }}>Email</label>
                            <input type="email" id="email" title="Email" ref={r => this.email = r} required />
                        </div>
                        <button type="submit" disabled={this.state.processing}>
                            Send Me Instructions
              <div className="bounceloader">
                                <div className="bounce1"></div>
                                <div className="bounce2"></div>
                                <div className="bounce3"></div>
                            </div>
                        </button>
                    </form>
                </div>
            </div>
        )
    }
}

export default PasswordResetRequest



// WEBPACK FOOTER //
// client/components/auth/PasswordResetRequest.js